import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/QuickLinks")
);

const QuickLinksEditConfig = {
  emptyLabel: "Quick Links",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  return {
    component: "QuickLinks",
    props: {
      heading: props.heading,
      theme: props.theme,
      noBreak: props.singleRow,
      labelColor: props.labelColor,
      svgColor: props.svgColor,
      switchDefaultOpacity: props.switchDefaultOpacity,
      iconPosition: props.iconPosition,
      preventLabelWrap: props.preventLabelWrap,
      isV2Styling: props.isV2Styling,
      cells: (props.cells || []).map((item) => ({
        url: item.url,
        target: item.target,
        label: item.label,
        iconPosition: item.iconPosition,
        isV2Styling: item.isV2Styling,
        mobileLabel: item.mobileLabel,
        icon: item.icon?.markup
          ? undefined
          : {
              desktop: {
                id: "",
                type: "desktop",
                src: item.icon?.src,
                alt: item.altText || "",
                width: "",
                height: "",
              },
            },
        svgColor: item.icon?.color,
        markup: item.icon?.markup,
      })),
    },
  };
};

const QuickLinks = (props) => {
  const data = transformData(props);
  return <Component common={props} {...data.props} />;
};

export default withAemIntegration("lexus/components/quick-links")(
  QuickLinks,
  QuickLinksEditConfig
);
